module.exports = __webpack_public_path__ + "img/simo2.3b0fc589.png";